import { useAsyncDataFromQuery } from "@tsmono/react/hooks";
import { AsyncData } from "@tsmono/util";

import {
  databaseLogsListingKeyRoot,
  readLogsOverview,
  type LogsOverview,
  type LogsOverviewView,
} from "../../log_data";

interface UseLogsOverviewParams {
  logDir: string;
  /** Cache identity of the view (see `useDatabaseLogsListingQuery`'s
   *  `universe`) — everything `view` reads beyond the records. `undefined`
   *  while the scope is hydrating (disables the query). */
  universe: string | undefined;
  view: LogsOverviewView;
}

/**
 * The page-level aggregates beside the row query (see `readLogsOverview`).
 * Keyed under the listing root so the write path's throttled invalidation
 * refreshes it alongside the row queries.
 */
export const useLogsOverview = ({
  logDir,
  universe,
  view,
}: UseLogsOverviewParams): AsyncData<LogsOverview> => {
  return useAsyncDataFromQuery({
    queryKey: [...databaseLogsListingKeyRoot, "overview", logDir, universe],
    queryFn: () => readLogsOverview(logDir, view),
    enabled: universe !== undefined,
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
